<template>
<button
  @click="changeTab"
  type="button"
  class="tab-button"
  :class="{ active: item.show }"
  :id="`tab-${slugify(item.name)}`"
  :data-testid="`tab-btn-${slugify(item.name)}`"
>
  <span class="tab-name">{{item.name}}</span>
</button>
</template>

<script>
import {slugify} from '../../utils/helpers';

export default {
  name: 'TabButton',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    slugify,
    changeTab() {
      this.$emit('changedTab', {
        tab: this.item.id
      });
    }
  }
};
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

.tab-name {
  font-size: 14px;
  display: block;
}

.tab-button {
  height: 100%;
  width: 100%;
  text-decoration: none;
  text-transform: uppercase;
  color: $text-color;
  padding: 5px 15px;
  transition: background-color 0.3s;
  border-radius: 5px;
  font-weight: 700;
  border: 0;
  box-shadow: none;
  cursor: pointer;
  text-align: center;
  line-height: 1.3;
  background-color: $teal;

  &.active {
    background-color: #fff;
  }

  &:hover,
  &:active:hover {
    background-color: $light-teal;
    text-decoration: none;
    // transition: background-color .3s;
  }
}
</style>

